import React, { useEffect } from "react";

import Img1 from "../Assets/img/feature-page-img/img-1.svg";
import Img2 from "../Assets/img/feature-page-img/img-2.jpg";
import Img3 from "../Assets/img/feature-page-img/img-3.png";
import Img4 from "../Assets/img/feature-page-img/img-4.png";
import Img5 from "../Assets/img/feature-page-img/img-5.png";
import Img6 from "../Assets/img/feature-page-img/img-6.png";
import Img7 from "../Assets/img/feature-page-img/img-7.png";
import Img8 from "../Assets/img/feature-page-img/img-8.png";
import Img9 from "../Assets/img/feature-page-img/img-9.png";
import Img10 from "../Assets/img/feature-page-img/img-10.png";
import Img11 from "../Assets/img/feature-page-img/img-11.png";
import Img12 from "../Assets/img/feature-page-img/img-12.png";
import Img13 from "../Assets/img/feature-page-img/img-13.png";
import Img14 from "../Assets/img/feature-page-img/img-14.jpg";
import Img15 from "../Assets/img/feature-page-img/img-15.png";
import Img16 from "../Assets/img/feature-page-img/img-16.png";
import Img17 from "../Assets/img/feature-page-img/img-17.png";
import Img18 from "../Assets/img/feature-page-img/img-18.png";
import Img19 from "../Assets/img/feature-page-img/img-19.png";
import Img20 from "../Assets/img/feature-page-img/img-20.png";
import Img21 from "../Assets/img/feature-page-img/img-21.png";
import Img22 from "../Assets/img/feature-page-img/img-22.png";
import Img23 from "../Assets/img/feature-page-img/img-23.jpg";
import Img24 from "../Assets/img/feature-page-img/img-24.png";
import Img25 from "../Assets/img/feature-page-img/img-25.png";
import SoftwareFeatureImg from "../Assets/img/software-feature.png";
import GooglePlayIcon from "../Assets/img/gplay.png";
import CheckIcon from "../Assets/img/features-details/check-square.png";
import GetApp from "../Components/GetApp";
const WebFeatures = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* <!-- Hero-Area --> */}
      <section className="a-isp-area features-bc bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="a-isp-content">
                <h1>ISP Digital, Your Trusted Partner</h1>
                <p>
                  ISP Digital offers a better way to manage your sales,
                  projects, team, clients, and marketing all in one place with a
                  single piece of software. It is designed with extensive
                  features which enable ISP businesses to easily find all tasks,
                  estimates, customer interactions, contact information,
                  analytical reports, and automate repetitive tasks. ISP Digital
                  Software allows businesses to run smoothly by simplifying
                  daily processes for profitability and growth, which
                  accelerates business development as well as gives companies
                  long-term success.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 order-top">
              <div className="a-isp-img">
                <img src={SoftwareFeatureImg} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- End-Hero-Area -->	 */}

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Multiple Branch Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Multiple Branch can be managed by a SuperAdmin.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Each branch will get individual credentials.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Generate all kinds of reports.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    All customers of each branch will be able to pay their bill
                    through Payment Gateway.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    All customers of each branch will get android app.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img1} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img2} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Client Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Import PPPoE/Static ID, Password & Profile from Mikrotik.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Export PPPoE/Static ID, Password & Profile from Excel.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add New Client Request.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Active, Inactive, Personal, Free and Left Client List.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    View Client Profile with All History.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Mikrotik User Credentials Can Be Change From Software.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Internet Connectivity Enable/Disable Anytime.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Caller ID / MAC Address Lock & Unlock.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client Status and Package Scheduler System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client Status and Package Change Request.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bulk Status Change.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client Assigning System for Employees.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    All Client Auto Sync from Mikrotik.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send Client Information to Mikrotik.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client Portal (Android/Web) Management System.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Data Filtering System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Total Client List Download (PDF or Excel).
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Keep Record of Left Client List.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Billing Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Monthly Auto Bill Generate System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Set Payment Deadline & Commitment Date.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Bill Remainder SMS With Their Bill Amount.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Invoice Send To Client Through E-Mail And SMS..
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Billing Date Wise Auto Disconnect.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Billing Date Extended Facility.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Data Filtering System.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Download & Print Billing List (PDF & Excel).
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Download & Print Billing Invoice.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Advance & Due Bill Receive With Discount Facility.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Collection & Provide Money Receipt By Pocket Printer.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Enable Connectivity When All Dues Are Paid.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online Bill Payment by Client Through Payment Gateway.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Outside Bill Payment by Short Link.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Collection by Employee & Admin Approval System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Payment Entry & Send Money Receipt By SMS To Client.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Billing History At A Glance.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 order-top sticky-img">
              <div className="dash-feature">
                <img src={Img3} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img4} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">HR & Payroll</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Configure Department & Designation.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Employee with Detail Information.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Salary Generate & Payment.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Employee Profile with Salary History.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bonus, Overtime, Incentive Payment Option.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Maintain Attendance Manually & Automatically.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Employee performance appraisal.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Complete HR & Payroll Solution.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Support & Ticketing</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Configure Problem Category as Your need.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Daily Complain Informed by Client.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Notify Client Through SMS About Complain.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Assign Employee to Solve the Problem & Notify by SMS.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Calculate the Total Taken Time of Problem Solving.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Monitor the Total Process & Know the Current Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    After Solved, Notify the Client by SMS.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Configure, Manage & Assign Internal Task.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Keep Record All the Support & Task History.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Evaluate Employee Who Solve Most problem.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img5} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img6} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Task Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create task planning.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Maintain task scheduling.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Start every day with new tasks and check task history.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Purchase Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Vendors List.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create requisition.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Make purchase item.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Purchase Bill.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img7} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img8} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Inventory Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Total Inventory Solution of Any Products.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Your Vendor & Customers with Details.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Your Products with Details.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Purchase, Sale, Stock & Supply Management.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Generate & Print Voucher, Invoice or Money Receipt.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send Invoice or Money Receipt through SMS or Email.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Record Transactions of Bill Payment & Bill Received.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Your Products with Details.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Network Diagram</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    View Network Diagram
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    View Network POP
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Monitor all Clients in Diagram.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    View Network Connection.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Distributed Inventory Items
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    View Network Diagram in Map.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img9} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img10} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Accounts Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Total Accounts Solution of Your Business.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Entry Category wise Daily Expense.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Any Service-Related Income.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Keep Records of All Financial Transactions.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Automatic Calculate the Profit or Loss.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Know About the Bank Deposit & Cash on Hand.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Ensuring Business Transparency.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Generate & Print Monthly Balance Sheet.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Asset Management</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Maintain Asset List.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Save the list of destroyed items.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img11} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img12} alt="#" />
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Bandwidth Purchase</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Bandwidth Item.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Bandwidth Provider
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth Provider list with ledger amount.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Bandwidth purchase Bill.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth Bill payment.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Month wise bill & payment history.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Bandwidth Sales</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Bandwidth Reseller.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Reseller list with ledger amount.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Bandwidth Sells Invoice.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send invoice to Reseller through E-mail.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send invoice Info to Reseller through sms.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Recieve Reseller Payment.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img13} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img14} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Bandwidth Reseller Portal</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Unlimited Bandwidth Reseller With Reseller Panel.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth reseller can manage their billing invoices.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth reseller can purchase their bandwidth item
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth reseller can generate their ticket for support.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bandwidth reseller can update their company profile
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">MAC Reseller Portal</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Create Unlimited MAC Reseller With Reseller Panel.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Configure Package & Tariff Plan for MAC Reseller.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    MAC Reseller can be configured by their own business.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Calculate & Charge Bill on Daily Basis.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Total Bill Payment & Charge History of mac Reseller.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    MAC Reseller Can Create & Update Own Client Profile.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client Enable & Disable Option by Mac Reseller.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Clients & Billing Feature Same as Admin Panel.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    MAC Reseller Can Manage Customer Complaints.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    MAC Reseller Can View the Online Customer List.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Manage Employee Salaries and Attendance.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Informative & Beautiful Dashboard for Mac Reseller.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    MAC Reseller SMS Module Same as Admin.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Debit and Credit Status.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img15} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img16} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Admin Portal (Web & APP)</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Receive Through POS Printer
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Entry System
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Complete Billing Report
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Easy Support & Ticketing Management
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online Client Monitoring
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Effective Task Management
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Employee Portal (Web/APP)</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Receive Through POS Printer
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Entry System
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Complete Billing Report
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Easy Support & Ticketing Management
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online Client Monitoring
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Effective Task Management
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img17} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img18} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Client Portal (Web & App)</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Informative Dashboard for Clients.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    All Information About the Clients Profile.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Package Upgrade Request System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Bill Payment Through Online by Client Own.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Request for Support & Ticketing.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Real Time Speed Test for Upload & Download.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    FTP or Live TV Server Link at Client Panel.
                  </li>

                  <li>
                    <img src={CheckIcon} alt="#" />
                    Live Chatting.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Notice and News upload.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Android Application
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">BTRC Report</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Generate DIS Report for BTRC by One Click.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Download as CSV or PDF File.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Download & Submit to BTRC in Every Month.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Generate According to the Format of BTRC.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Save Your Valuable Time.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img19} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img20} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Mikrotik Integration</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Integrated with Mikrotik API.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add Unlimited Mikrotik Router.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Sync with Mikrotik Information in Real Time.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    PPPoE & Static IP Will Be in Both Sides.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online Monitoring System.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    No Harmful Effects on Your Mikrotik Router.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Keep Backup Your Mikrotik Server Everyday Automatically.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Changing Mikrotik or Set Up A New Mikrotik within One
                    Minute.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Informative Dashboard</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Informative and Attractive Dashboard
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Active, Inactive clients status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    New, Renewed, Deactivated and Left Clients Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Paid, Partial, Unpaid and Blocked Clients Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online, Expire and Extended Clients Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Total MAC Reseller, MAC Clients, Active and Inactive Clients
                    Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Zone and Category Wise Problem Graph.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Clients Ticket and Task Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Most Problem Solver Graph.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Monthly New Clients Graph.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Active Clients Wise Company Performance.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Top 20 Unpaid Clients Graph.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    SMS Balance, Collected Bill, Due Bill, Discount and
                    Installation Charge Status.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Monthly Income and Expense Status.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img21} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img22} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Business Configuration</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Zone, Sub Zone, POP/BOX and Device Setup.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Client, Payment and Data Connectivity Type Setup.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Internet Package Configuration.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Billing Status Wise Auto Process Setup.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Invoice & Money Receipt Setup.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Invoice Generate Period Setup.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Automated or Customized Client Code.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Online Payment Gateway</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    API Integrated with Online Payment Gateway.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Easily Bill Payment by Client Own.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Automatic Payment Add to Your Billing List.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Auto Enable Connection After Payment.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Highly Secured & Safety Ensured.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    bKash, Rocket, SSLCommerz & Foster Payments.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img23} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area off-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img24} alt="#" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Bulk SMS & Mailing System</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Automatic Send SMS & Email to Your Client.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Payment Due Notification by SMS & Email.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send Invoice & Money Receipt.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Support & Ticketing Related Notification by SMS.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Individual or Group SMS From Software.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Add SMS Template for Multiple Use.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Send Promotional SMS for Marketing.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Notify About Emergency Announcement.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-details-area ">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <h4 className="features-title">Role Based Permission</h4>
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Different Role for Different User.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Assign the Responsibility Based on Their Role
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Access & Perform Only Provided Duties.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Ensure the Confidentiality of Your Business.
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    System of Billing Approval by Admin.
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12 sticky-img">
              <div className="dash-feature">
                <img src={Img25} alt="#" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <GetApp />
      <section className="features-details-area">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h4 className="features-title text-center">App Features</h4>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Real Time Traffic Monitoring
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Support & Ticketing
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Router Connectivity Test
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="features-details-list">
                <ul>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Online Payment System
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    Package Change Request
                  </li>
                  <li>
                    <img src={CheckIcon} alt="#" />
                    News & Event
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="features-cta">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="f-cta-inner">
                <div className="fcta-heading-main">
                  <h2>
                    For Better Experience Download the app from Google Play
                    Store
                  </h2>
                </div>
                <div className="app-store-logo">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.softifybd.ispdigital"
                    target="_blank"
                  >
                    <img src={GooglePlayIcon} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WebFeatures;
